var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 548,
    viewBox: "0 0 1440 548",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_305_1658)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_305_1658)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2027.43 -632.577L1890.82 -87.3638C1884.9 -63.7294 1859.4 -50.8347 1836.86 -60.0715L1645.61 -138.423L1100.36 116.048C966.505 178.52 869.604 300.044 838.5 444.45L598.58 1558.31L698.232 1623.3L967.685 372.328C980.784 311.515 1005.77 253.89 1041.21 202.765L1422.37 -347.056L2039.72 -167.985L2127.08 -567.586L2027.43 -632.577Z",
    fill: "url(#paint0_linear_305_1658)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_305_1658",
    x1: 901.423,
    y1: 194.444,
    x2: 1659.04,
    y2: -339.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCE5",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4060EA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_305_1658"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 548,
    fill: "white",
    transform: "translate(0 0.000976562)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_305_1658"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 527,
    height: 245,
    fill: "white",
    transform: "translate(913)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactBg);
export default __webpack_public_path__ + "static/media/ContactBg.a337f8a16207ae0fb8cadc907f6b28cb.svg";
export { ForwardRef as ReactComponent };